import { Skeletons } from "@callcenter/design-system"

import styles from "./user-account-form-skeleton.module.pcss"
import mainStyles from "../../shared/styles.module.pcss"

export const UserAccountInfoSkeleton = () => (
  <>
    <div className={mainStyles.accountInfoBlockWrapper}>
      <Skeletons.SkeletonLine width="160px" height="24px" />
      <div>
        <div className={mainStyles.accountInfoLine}>
          <Skeletons.SkeletonLine width="118px" height="20px" />
          <Skeletons.SkeletonLine width="118px" height="20px" />
        </div>
        <div className={mainStyles.accountInfoLine}>
          <Skeletons.SkeletonLine width="160px" height="20px" />
          <Skeletons.SkeletonLine width="118px" height="20px" />
        </div>
        <div className={mainStyles.accountInfoLine}>
          <Skeletons.SkeletonLine width="118px" height="20px" />
          <Skeletons.SkeletonLine width="118px" height="20px" />
        </div>
      </div>
    </div>
    <div className={mainStyles.selectSectionWrapper}>
      <Skeletons.SkeletonLine width="160px" height="24px" />
      <div className={styles.selectSkeleton}>
        <Skeletons.SkeletonLine width="118px" height="20px" />
        <Skeletons.SkeletonLine height="32px" />
      </div>
      <div className={styles.selectSkeleton}>
        <Skeletons.SkeletonLine width="160px" height="20px" />
        <Skeletons.SkeletonLine height="32px" />
      </div>
    </div>
  </>
)
